// Import jQuery
import $ from 'jquery';

window.$ = $;

import './modules/MegaMenu';
import './modules/Search';
import './modules/Splide';
import { initSelectServices } from './modules/SelectServices';
import { initMobileMenu } from './modules/MobileMenu';
import { initServiceGridWaves } from './modules/ServiceGridWaves';
import 'foundation-sites/dist/js/plugins/foundation.util.keyboard.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.touch.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.nest.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.box.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.triggers.min.js';
import 'foundation-sites/dist/js/plugins/foundation.util.motion.min.js';
import 'foundation-sites/dist/js/plugins/foundation.offcanvas.min.js';
import 'foundation-sites/dist/js/plugins/foundation.drilldown.min.js';

document.addEventListener('DOMContentLoaded', function () {
    initSelectServices();
    $(document).foundation();
    initMobileMenu();
    initServiceGridWaves();

    const offCanvas = document.getElementById('offCanvas');

    if (!offCanvas) {
        return;
    }

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'class') {
                const isOpen = offCanvas.classList.contains('is-open');
                if (isOpen) {
                    document.documentElement.classList.add('is-off-canvas-open');
                } else {
                    document.documentElement.classList.remove('is-off-canvas-open');
                }
            }
        });
    });

    observer.observe(offCanvas, {
        attributes: true,
        attributeFilter: ['class'],
    });

    if (offCanvas.classList.contains('is-open')) {
        document.documentElement.classList.add('is-off-canvas-open');
    }
});

import SearchPeople from './modules/SearchPeople';

function initSearchPeople() {
    if (!document.querySelector('.search-people__input')) return;
    new SearchPeople();
}

window.addEventListener('DOMContentLoaded', initSearchPeople);
window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        initSearchPeople();
    }
});
